import React from "react";
import "./Hobbies.css";
import { motion } from "framer-motion";

const hobbies = [
  { name: "Photography", size: "8rem", color: "#FFD1DC", duration: 2 },
  { name: "Cooking", size: "6rem", color: "#FFDAC1", duration: 3 },
  { name: "Traveling", size: "7rem", color: "#B5EAD7", duration: 2.5 },
  { name: "Reading", size: "5rem", color: "#C7CEEA", duration: 3.5 },
  { name: "Gaming", size: "9rem", color: "#FFB7B2", duration: 2.2 },
  { name: "Workout", size: "6rem", color: "#FF9AA2", duration: 3 },
  { name: "Cycling", size: "6.5rem", color: "#D5AAFF", duration: 2.8 },
  { name: "Running", size: "7rem", color: "#A0E7E5", duration: 2.3 },
  { name: "Swimming", size: "5.5rem", color: "#FBE7C6", duration: 3 },
  { name: "Martial Arts", size: "8rem", color: "#FFCCF9", duration: 2.5 },
  { name: "DJing", size: "6.5rem", color: "#FFC1E3", duration: 2.8 },
  { name: "Stand-Up Comedy", size: "7rem", color: "#FFABAB", duration: 3 },
  { name: "Filmmaking", size: "8rem", color: "#D4A5A5", duration: 2.7 },
  { name: "Vlogging", size: "6rem", color: "#FFCF9F", duration: 2.5 },
  { name: "Podcasting", size: "7rem", color: "#FFA8A8", duration: 2.2 },
  { name: "Dancing", size: "8.5rem", color: "#B5D5C5", duration: 2.6 },
  { name: "Parkour", size: "6.8rem", color: "#FFC4C4", duration: 3 },
  { name: "Fishing", size: "6rem", color: "#FFDAAF", duration: 2.9 },
  { name: "Bird Watching", size: "5.5rem", color: "#FFD4E5", duration: 2.2 },
  { name: "Stargazing", size: "7.5rem", color: "#C6CFFF", duration: 2.8 },
  { name: "Snorkeling", size: "8rem", color: "#B5A1FF", duration: 2.5 },
  { name: "Geocaching", size: "6.5rem", color: "#FFC9A6", duration: 3 },
  { name: "Robotics", size: "7rem", color: "#FFA0A0", duration: 3.2 },
  { name: "Coding", size: "8rem", color: "#A1E3D8", duration: 2.7 },
  { name: "Drones", size: "7rem", color: "#F5B3B3", duration: 2.2 },
  { name: "Automotive", size: "6rem", color: "#FFBABD", duration: 2.9 },
  { name: "Finance Advices", size: "6.5rem", color: "#FFEBB7", duration: 2.6 },
  { name: "Collecting", size: "6rem", color: "#FFC3D3", duration: 3 },
  { name: "Board Games", size: "7rem", color: "#B5D8E0", duration: 2.8 },
  { name: "Chess", size: "6rem", color: "#FFB4B7", duration: 2.7 },
  { name: "Puzzle Solving", size: "8rem", color: "#C7A1E8", duration: 2.2 },
  { name: "Lego Building", size: "7rem", color: "#FFD8A8", duration: 3 },
  { name: "Astrology", size: "6.5rem", color: "#B5B5FF", duration: 2.9 },
  { name: "Fantasy Sports", size: "6.8rem", color: "#FFC3AB", duration: 3 },
  { name: "Gardening", size: "7rem", color: "#A5D5A5", duration: 3 },
  { name: "Farming", size: "6.5rem", color: "#FFDAC1", duration: 2.8 },
  { name: "Home Decor", size: "7rem", color: "#D5A5B5", duration: 3.1 },
  { name: "Antique Hunting", size: "6rem", color: "#FFC1C1", duration: 3 },
  { name: "Upcycling", size: "6.5rem", color: "#FFB5B5", duration: 2.9 },
  { name: "Thrift Shopping", size: "7rem", color: "#B5E8D5", duration: 2.8 },
  { name: "Carpentry", size: "6rem", color: "#D5B5E8", duration: 2.2 },
  { name: "Yoga", size: "7rem", color: "#A5D5C5", duration: 2.6 },
  { name: "Meditation", size: "6.5rem", color: "#FFC3C3", duration: 3 },
  { name: "Self-Improvement", size: "8rem", color: "#B5A5C5", duration: 3.2 },
  { name: "Relationship", size: "6.5rem", color: "#D5A1FF", duration: 2.7 },
  { name: "Philosophical Topic", size: "7rem", color: "#A5C5FF", duration: 3 },
  { name: "Beekeeping", size: "6rem", color: "#FFD1A5", duration: 2.8 },
  { name: "Herbalism", size: "6.5rem", color: "#B5FFC3", duration: 3 },
  { name: "Mushroom Hunting", size: "7rem", color: "#D5C1FF", duration: 2.2 },
  { name: "Flower Arranging", size: "7rem", color: "#FFC1B5", duration: 2.9 },
  { name: "Writing", size: "6.5rem", color: "#B5D1FF", duration: 3.2 },
  { name: "Blogging", size: "7rem", color: "#FFD5A1", duration: 2.7 },
  { name: "Investing", size: "6rem", color: "#D1A1FF", duration: 2.2 },
  { name: "Parenting", size: "6.5rem", color: "#A5B5FF", duration: 2.8 },
  { name: "Pet Care", size: "7rem", color: "#FFC1A5", duration: 3 },
  { name: "Fashions", size: "7rem", color: "#D5C3FF", duration: 2.9 },
  { name: "Makeup Artistry", size: "6.8rem", color: "#FFA5A5", duration: 3 },
  { name: "Magic Tricks", size: "7.2rem", color: "#FFCCB5", duration: 3 },
  { name: "Architecture", size: "7rem", color: "#C5B5FF", duration: 3.1 },
  { name: "Volunteering", size: "6.5rem", color: "#A5D5B5", duration: 3 },
  { name: "Caregiving", size: "6rem", color: "#FFC1D5", duration: 2.8 },
  { name: "Surfing", size: "7rem", color: "#B5B3FF", duration: 3 },
  { name: "Skiing", size: "6.8rem", color: "#FFD5A1", duration: 2.9 },
  { name: "Snowboarding", size: "7rem", color: "#C7B5E8", duration: 3.2 },
  { name: "Ice Skating", size: "6rem", color: "#FFA8D8", duration: 3.1 },
  { name: "Rock Climbing", size: "7.5rem", color: "#B5D5C5", duration: 2.2 },
  { name: "Camping", size: "6.5rem", color: "#FFD1A5", duration: 3.3 },
  { name: "Archery", size: "7rem", color: "#A5C5FF", duration: 2.9 },
  { name: "Hiking", size: "6rem", color: "#FFDAC1", duration: 3 },
  { name: "Golf", size: "7rem", color: "#D5B5FF", duration: 3.2 },
  { name: "Pilates", size: "6.5rem", color: "#B5A1E3", duration: 3.1 },
  { name: "Boxing", size: "7rem", color: "#FFC1A5", duration: 3 },
  { name: "Kayaking", size: "6rem", color: "#FFB5D5", duration: 2.8 },
  { name: "Scubadiving", size: "7rem", color: "#C5D1FF", duration: 3.1 },
  { name: "Skydiving", size: "7.5rem", color: "#FFD8B5", duration: 2.2 },
  { name: "Paragliding", size: "6.5rem", color: "#B5E3C5", duration: 3.3 },
  { name: "Fencing", size: "7rem", color: "#A5D1FF", duration: 2.9 },
  { name: "Horseback Riding", size: "6.8rem", color: "#FFCCB5", duration: 3 },
  { name: "Sailing", size: "7rem", color: "#C7B5FF", duration: 3.2 },
  { name: "Baseball", size: "6rem", color: "#FFA5B5", duration: 2.2 },
  { name: "Drawing", size: "6.5rem", color: "#D5C1FF", duration: 3.3 },
  { name: "Painting", size: "7rem", color: "#FFC1C1", duration: 3.1 },
  { name: "Crafting", size: "6rem", color: "#B5E8D5", duration: 2.8 },
  { name: "Cryptocurrency", size: "7rem", color: "#FFDAC1", duration: 2.2 },
  { name: "Knitting", size: "6.5rem", color: "#B5A5E3", duration: 2.9 },
  { name: "Pottery", size: "7rem", color: "#D5B5A5", duration: 3.2 },
  { name: "Sewing", size: "6rem", color: "#FFB5A5", duration: 2.8 },
  { name: "Jewelry Making", size: "6.5rem", color: "#A5D1FF", duration: 3.1 },
  { name: "Woodworking", size: "7rem", color: "#FFC1C5", duration: 3 },
  { name: "Leatherworking", size: "6.8rem", color: "#C7B5E8", duration: 3.3 },
  { name: "Glassblowing", size: "7rem", color: "#FFD8A1", duration: 3.2 },
  { name: "Calligraphy", size: "6rem", color: "#B5D5B5", duration: 2.9 },
  { name: "Metalworking", size: "7rem", color: "#A5C5FF", duration: 3.4 },
  { name: "Model Building", size: "6.5rem", color: "#FFB5D5", duration: 3.1 },
  { name: "Origami", size: "7rem", color: "#D5B5FF", duration: 2.2 },
  { name: "Cosplay", size: "6rem", color: "#FFD1C1", duration: 3 },
  { name: "Graphic Design", size: "7rem", color: "#C5D1FF", duration: 3.3 },
  { name: "Scrapbooking", size: "6.5rem", color: "#FFA5D8", duration: 3.1 },
  { name: "Quilting", size: "7rem", color: "#D5A1FF", duration: 3 },
  { name: "Home Brewing", size: "6rem", color: "#B5FFC3", duration: 2.8 },
  { name: "Fermenting", size: "6.5rem", color: "#C7E8A1", duration: 3 },
  { name: "Candle Making", size: "7rem", color: "#FFC1B5", duration: 3.1 },
  { name: "Soap Making", size: "7rem", color: "#B5A1E8", duration: 3 },
  { name: "Music", size: "6.8rem", color: "#FFD5B5", duration: 3 },
  { name: "Singing", size: "7rem", color: "#C7D5FF", duration: 3.1 },
];

const bubbleVariants = (duration) => ({
  initial: {
    scale: 0.6,
    opacity: 0,
    x: Math.random() * window.innerWidth - window.innerWidth / 3,
    y: Math.random() * window.innerHeight - window.innerHeight / 3,
  },
  animate: {
    scale: [1, 1.2, 1],
    opacity: 1,
    x: 0,
    y: 0,
    transition: {
      duration: duration,
      repeat: Infinity,
      repeatType: "mirror",
      ease: "easeInOut",
    },
  },
});

const Hobbies = () => {
  return (
    <div className="hobbies" id="Hobbies">
      {/* Left Side */}
      <div className="hobbytext">
        <span>Various niches</span>

        <span>At Hobbestie, we celebrate a vast array of niche hobbies.</span>
        <span>
          If your passion isn't featured yet, let us know, and we'll work to
          include it.
        </span>

        <div className="blur s-blur1"></div>
      </div>
      {/* Right Side */}
      <div className="w-right">
        <div className="w-mainCircle">
          {hobbies.map((hobby, index) => (
            <motion.div
              key={index}
              className="w-secCircle"
              variants={bubbleVariants(
                hobby.duration,
                Math.random() * 100 - 50,
                Math.random() * 100 - 50
              )}
              initial="initial"
              animate="animate"
              style={{
                width: hobby.size,
                height: hobby.size,
                backgroundColor: hobby.color,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              {hobby.name}
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Hobbies;
